/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { BrowseSearchMetadata }
from '@thd-olt-component-react/metadata';

import { TrackOrder }
from '@thd-olt-component-react/track-order';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { SponsoredBannerComposable }
from '@thd-olt-component-react/sponsored-content';

import {
  PLPResultsHeader, ResultsAppliedComposable, ResultsFilterAndSortDrawerComposable, ResultsDimensionsComposable, ResultsSortByComposable, ResultsPaginationComposable
}
from '@thd-olt-component-react/product-results';

import { ProductCategoryVisnavComposable }
from '@thd-olt-component-react/product-category-visnav';

import { FlooringDrawer }
from '@thd-olt-component-react/flooring-picker';

import { DefaultGridComposable }
from '@thd-olt-component-react/plp-grid';

import { CompareTrayComposable }
from '@thd-olt-component-react/compare';

import { SearchFeedback }
from '@thd-olt-component-react/search-feedback';

import { HdhomeSignup }
from '@thd-olt-component-react/email-signup';

import { PLPRecsComposable, PlpRvRenderPlaceholder }
from '@thd-olt-component-react/thd-recs-containers';

import { RetailMediaCarouselFusionComposable }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { RelatedSearch }
from '@thd-olt-component-react/related-search';

import { BrowseSearchRedirector }
from '@thd-nucleus/app-render';

import { TempDatasourcesHackForFusionDataModels }
from '@thd-olt-component-react/temp-datasources-hack-for-fusion-dataModels';

export { BrowseSearchMetadata };

export { TrackOrder };

export { Breadcrumbs };

export { SponsoredBannerComposable };

export { PLPResultsHeader };

export { ProductCategoryVisnavComposable };

export { ResultsAppliedComposable };

export { ResultsFilterAndSortDrawerComposable };

export { ResultsDimensionsComposable };

export { ResultsSortByComposable };

export { FlooringDrawer };

export { DefaultGridComposable };

export { CompareTrayComposable };

export { ResultsPaginationComposable };

export { SearchFeedback };

export { HdhomeSignup };

export { PLPRecsComposable };

export { RetailMediaCarouselFusionComposable };

export { PlpRvRenderPlaceholder };

export { RelatedSearch };

export { BrowseSearchRedirector };

export { TempDatasourcesHackForFusionDataModels };

const SlotA1 = withLayout(
  [

    BrowseSearchMetadata,

  ],

);

const SlotA2 = withLayout(
  [

    TrackOrder,

  ],

);

const SlotA3 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotB1 = withLayout(
  [

    SponsoredBannerComposable,

  ],

);

const SlotB2 = withLayout(
  [

    PLPResultsHeader,

  ],

);

const SlotB3 = withLayout(
  [

    ProductCategoryVisnavComposable,

  ],

);

const SlotC1 = withLayout(
  [

    ResultsAppliedComposable,

  ],

);

const SlotC2 = withLayout(
  [

    ResultsFilterAndSortDrawerComposable,

  ],

);

const SlotD1 = withLayout(
  [

    ResultsDimensionsComposable,

  ],

);

const SlotE1 = withLayout(
  [

    ResultsSortByComposable,

  ],

);

const SlotF1 = withLayout(
  [

    FlooringDrawer,

  ],

);

const SlotF2 = withLayout(
  [

    DefaultGridComposable,

  ],

);

const SlotF3 = withLayout(
  [

    CompareTrayComposable,

  ],

);

const SlotF4 = withLayout(
  [

    ResultsPaginationComposable,

  ],

);

const SlotF5 = withLayout(
  [

    SearchFeedback,

  ],

);

const SlotF6 = withLayout(
  [

    HdhomeSignup,

  ],

);

const SlotG1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

const SlotG2 = withLayout(
  [

    RetailMediaCarouselFusionComposable,

  ],

);

const SlotG3 = withLayout(
  [

    PlpRvRenderPlaceholder,

  ],

);

const SlotG4 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotG5 = withLayout(
  [

    BrowseSearchRedirector,

  ],

);

const SlotG6 = withLayout(
  [

    TempDatasourcesHackForFusionDataModels,

  ],

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

  SlotA3,

  SlotB1,

  SlotB2,

  SlotB3,

  SlotC1,

  SlotC2,

  SlotD1,

  SlotE1,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotF4,

  SlotF5,

  SlotF6,

  SlotG1,

  SlotG2,

  SlotG3,

  SlotG4,

  SlotG5,

  SlotG6,

};
